import * as api from "Api";

class PresentationApi {
  fetchDashboard(year, uen, lng, token) {
    return api.getDashboard({
      year,
      uen,
      token,
      language: lng
    });
  }
}

export default new PresentationApi();



// WEBPACK FOOTER //
// ./src/services/presentationServices.js